import { FieldArray } from "formik";
import React from "react";
import AddLinksFormWithoutDrag from "./AddLinksFormWithoutDrag";
import AddSocialLinksForm from "./LinkVault/children/AddSocialLinksForm";

const AddLinksBusinessBoxForm = ({ showErrors = false }) => {
  return (
    <FieldArray
      name="business_link"
      render={(props) => {
        return (
          // <AddLinksFormWithoutDrag
          //   {...props}
          //   name="business_link"
          //   showErrors={showErrors}
          // />
          <AddSocialLinksForm {...props} />
        );
      }}
    />
  );
};

export default AddLinksBusinessBoxForm;
